<template>
  <div :id="mapId" class="map w-full">
    <google-map-marker :lat="this.lat" :lng="this.lng" ref="marker"></google-map-marker>
  </div>
</template>
<script>
import {v4 as uuidv4} from 'uuid';
import GoogleMapMarker from "@/components/map/GoogleMapMarker";

export default {
  components: {
    GoogleMapMarker
  },
  data() {
    return {
      map: null
    }
  },
  props: {
    googleApiKey: {
      type: String,
      required: true
    },
    lat: {
      type: Number,
      required: true
    },
    lng: {
      type: Number,
      required: true
    },
    zoom: {
      type: Number,
      default: 8
    }
  },
  computed: {
    mapId() {
      return uuidv4();
    }
  },
  methods: {
    initMap() {
      this.map = new window.google.maps.Map(document.getElementById(this.mapId), {
        center: {lat: this.lat, lng: this.lng},
        zoom: this.zoom,
        mapTypeControlOptions: {
          mapTypeIds: ["roadmap", "satellite", "hybrid", "terrain", "styled_map"],
        },
      });

      const styledMapType = new window.google.maps.StyledMapType([
        {
          "featureType": "administrative",
          "elementType": "all",
          "stylers": [
            {
              "saturation": "-100"
            }
          ]
        },
        {
          "featureType": "administrative.province",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
            {
              "saturation": -100
            },
            {
              "lightness": 65
            },
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
            {
              "saturation": -100
            },
            {
              "lightness": "50"
            },
            {
              "visibility": "simplified"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "all",
          "stylers": [
            {
              "saturation": "-100"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "simplified"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "all",
          "stylers": [
            {
              "lightness": "30"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "all",
          "stylers": [
            {
              "lightness": "40"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
            {
              "saturation": -100
            },
            {
              "visibility": "simplified"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "hue": "#ffff00"
            },
            {
              "lightness": -25
            },
            {
              "saturation": -97
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels",
          "stylers": [
            {
              "lightness": -25
            },
            {
              "saturation": -100
            }
          ]
        }
      ]);

      this.map.mapTypes.set("styled_map", styledMapType)
      this.map.setMapTypeId("styled_map")

      this.$refs.marker.mapReady(this.map);
    },
    checkAndAttachMapScript(callback) {
      if (!!window.google) {  // If you're using vue cli, then directly checking
        // 'google' obj will throw an error at the time of transpiling.
        callback();
        return true;
      }

      window.mapApiInitialized = callback;
      let script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.googleApiKey + '&libraries=places,geometry&callback=mapApiInitialized';
      document.body.appendChild(script);
    }
  },
  mounted() {
    this.checkAndAttachMapScript(this.initMap);
  }
}
</script>
<style lang="scss" scoped>
.map {
  height: 300px;
}
</style>